<template>
  <div class="photovoltaicSystem">
    <el-row :gutter="common.gutter">
      <el-col :span="18">
        <!-- "光伏总览" 开始 -->
        <div class="container">
          <my-title title="光伏总览"></my-title>
          <my-divider height="5px"></my-divider>
          <div id="flexBox">
            <div class="container-name-value container-name-value-hover">
              <div @click="$router.push('/photovoltaicStation')">
                <name-value-vertical-with-unit name="电站数量" :value="summary.powerStationCount"
                                               unit="个"></name-value-vertical-with-unit>
              </div>
            </div>
            <div class="container-name-value container-name-value-hover" @click="$router.push('/photovoltaicStation')">
              <span class="summary-value-1 active-1">{{ summary.inverterState.active }}</span>
              <span class="summary-value-1 summary-value-separator">/</span>
              <span class="summary-value-1 notActive">{{ summary.inverterState.notActive }}</span>
              <span class="summary-value-1 summary-value-separator">/</span>
              <span class="summary-value-1 alarm-1">{{ summary.inverterState.alarmNum }}</span>
              <my-divider :height="common.myDividerHeight1"></my-divider>
              <span>逆变器运行状态</span>
            </div>
            <div class="container-name-value">
              <name-value-vertical-with-unit name="装机总功率" :value="summary.InstalledPower"
                                             unit="kw"></name-value-vertical-with-unit>
            </div>
            <div class="container-name-value">
              <name-value-vertical-with-unit name="实时发电功率" :value="summary.power.toFixed(2)"
                                             unit="kw"></name-value-vertical-with-unit>
            </div>
            <div class="container-name-value">
              <name-value-vertical-with-unit name="补贴电价" :value="summary.SubsidizedElectricityPrice"
                                             unit="¥"></name-value-vertical-with-unit>
            </div>
            <div class="container-name-value container-name-value-hover"
                 @click="$router.push({ name: 'photovoltaicDevOps', params: { id: '告警' } })">
              <name-value-vertical-with-unit name="今日报警" :value="summary.todayAlarmCount"
                                             unit="次"></name-value-vertical-with-unit>
            </div>
          </div>
        </div>
        <!-- "光伏总览" 结束 -->

        <my-divider :height="common.myDividerHeight1"></my-divider>

        <!-- "左边列表和地图" 开始 -->
        <el-row :gutter="common.gutter">
          <el-col :span="6">
            <div class="container">
              <div style="text-align: center">
                <el-checkbox-group v-model="checkboxGroups.checkList"
                                   @change="checkboxGroupsMethods().checkboxChange($event)">
                  <el-checkbox label="电站"></el-checkbox>
                  <el-checkbox label="逆变器"></el-checkbox>
                  <el-checkbox label="摄像机"></el-checkbox>
                </el-checkbox-group>
              </div>
              <my-divider :height="common.myDividerHeight2"></my-divider>
              <input-with-button @search="checkboxGroupsMethods().search($event)"
                                 ref="childInputWithButton"></input-with-button>
              <my-divider :height="common.myDividerHeight1"></my-divider>
              <StationListWithCircle :height="listHeight" :data="checkboxGroups.dataListFiltered" @click="treeClick"
                                     :activeIndex="activeIndex"/>
            </div>

          </el-col>
          <el-col :span="18">
            <div :style="mapStyle">
              <map-view :menuData="checkboxGroups.menuData"></map-view>
            </div>
          </el-col>
        </el-row>
        <!-- "左边列表和地图" 结束 -->
      </el-col>
      <el-col :span="6">
        <!--"发电信息" 开始-->
        <name-value-with-dialog ref="childElectricity" id="myChartsElectricity" title="发电信息"
                                :data="electricity.nameValues" :charts-data="electricity.echarts.chartsData"
                                @openDialog="electricityMethods().openDialogElectricity($event)"
                                @periodChange="electricityMethods().periodChange($event)"></name-value-with-dialog>
        <!--"发电信息" 结束-->

        <my-divider :height="common.myDividerHeight1"></my-divider>

        <!--"视频信息" 开始-->
        <div class="container" :style="videoHeight">
          <div style="cursor: pointer;" title="跳转监控管理" @click="$router.push('/photovoltaicMonitor')">
            <my-title title="视频信息"></my-title>
          </div>
          <my-divider :height="common.myDividerHeight1"></my-divider>
          <template v-if="inverterIdVideo">
            <div style="width: 100%;height: 250px;display: inline-block;">
              <el-image style="width: 100%; height: 100%" :src="require('@/assets/images/video/noVideo.svg')"
                        fit="fill"></el-image>
            </div>
          </template>
          <VideoPlayerWithPagination v-else-if="stationIdVideo" :videoId=videoId :stationId="stationIdVideo"/>
          <div v-else style="width: 100%;height: 250px;display: inline-block;">
            <el-image v-if="notPlay" style="width: 100%; height: 100%"
                      :src="require('@/assets/images/video/noVideo.svg')"
                      fit="fill"></el-image>
            <VideoPlayer v-else :url='videoUrl' :isLive="isLive" :id="videoId" ref="videoRef" controls/>
          </div>
        </div>
        <!--"视频信息" 结束-->

        <my-divider :height="common.myDividerHeight1"></my-divider>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MyTitle from "@/components/MyTitle";
import NameValueVerticalWithUnit from "@/components/zixitong/airSystem/NameValueVerticalWithUnit";
import MyDivider from "@/components/MyDivider";
import Charts from "@/components/zixitong/elevatorSystem/Charts";
import FourSquares from "@/components/zixitong/photovoltaicSystem/FourSquares";
import NineSquares from "@/components/zixitong/photovoltaicSystem/NineSquares";
import api from "@/api";
import OmitLine from "@/components/EChartsFolder/OmitLine";
import NameValueWithDialog from "@/components/zixitong/photovoltaicSystem/NameValueWithDialog";
import MapView from "@/components/zixitong/indoorEnvironment/MapView";
import InputWithButton from "@/components/zixitong/photovoltaicSystem/InputWithButton";
// import ElMenuWithCircle from "@/components/zixitong/photovoltaicSystem/ElMenuWithCircle";

import StationListWithCircle from "@/components/zixitong/photovoltaicSystem/StationListWithCircle";
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer';
import VideoPlayerWithPagination from '@/components/VideoPlayer/VideoPlayerWithPagination';
import {nextTick} from "vue";

export default {
  components: {
    // ElMenuWithCircle,
    InputWithButton,
    MapView,
    NameValueWithDialog,
    NineSquares,
    FourSquares,
    Charts,
    MyDivider,
    NameValueVerticalWithUnit,
    MyTitle,
    OmitLine,

    StationListWithCircle,
    VideoPlayer,
    VideoPlayerWithPagination,
  },
  data() {
    return {
      common: {
        myDividerHeight1: "10px",
        myDividerHeight2: "20px",
        gutter: 10,
      },

      /* "光伏总览" 开始 */
      summary: {
        powerStationCount: 0,
        inverterState: {
          total: 0,
          alarmNum: 0,
          notActive: 0,
          active: 0,
        },
        todayAlarmCount: 0,
        SubsidizedElectricityPrice: 0,
        InstalledPower: 0,
        power: 0,
        voltage: 0,
      },
      /* "光伏总览" 结束 */

      /*"左边多选框" 开始*/
      checkboxGroups: {
        /**
         * @description 电站/逆变器/摄像机-显示的顺序
         * */
        checkListSort: ["电站", "逆变器", "摄像机"],
        checkList: ["电站", "逆变器", "摄像机"],
        dataList: [],
        dataListFiltered: [],
        itemCurrent: {},
        cameraFilter: "摄像",
        menuData: {
          PVList: [],
          PVClick: {},
        },
        latitude: "Latitude",
      },
      activeIndex: 0,
      /*"左边多选框" 结束*/

      /*"发电信息" 开始*/
      electricity: {
        /*name-value 开始*/
        nameValues: [
          {name: "今日发电", value: 0, unit: "kw·h"},
          {name: "本月发电", value: 0, unit: "kw·h"},
          {name: "今年发电", value: 0, unit: "kw·h"},
          {name: "累计发电", value: 0, unit: "kw·h"},
        ],
        /*name-value 结束*/

        /*图表开始*/
        echarts: {
          tab: "日",
          chartsData: {
            xData: [],
            yData: [],
            unit: "kw·h",
          },
        },
        /*图表结束*/
      },
      /*"发电信息" 结束*/

      /*"视频信息" 开始*/
      //点击摄像头，直接加载播放器
      activeItem: {
        url: "",
        urlBack: ""
      },
      videoId: 'videoPVOSystem',
      notPlay: true,
      timeFormatStr: '',
      isLive: true,
      // isPlay: false,
      visibleRate: false,
      //当前播放速率
      // rate: 1.0,
      //点击电站，需要先查询
      stationIdVideo: null,
      inverterIdVideo: null,
      /*"视频信息" 结束*/

      listHeight: '550px',
      mapStyle: 'width: 100%;height: 657px',
      videoHeight: 'height: 520px',
    };
  },
  computed: {
    videoUrl: function () {
      return this.isLive ? this.activeItem.url : this.activeItem.urlBack
    },
  },
  watch: {
    videoUrl(val) {
      if (this.stationIdVideo || this.inverterIdVideo) {
        return
      }
      if (!val) {
        this.notPlay = true
      } else {
        if (this.notPlay) {
          this.notPlay = false
        } else {
          // this.isPlay = false;
          this.$refs.videoRef.videoGetExeStatus()
        }
      }
    },
  },
  methods: {
    /*"光伏总览"方法 开始*/
    summaryMethods() {
      let that = this;
      return {
        async getSummaries() {
          let res = await api.photovoltaicGetPowerStationInfo({
            projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))[
                "projects"
                ][0].projectId,
          });
          if (res && res.status === 200) {
            that.summary = res.data.data;
          }
        },
      };
    },
    /*"光伏总览"方法 结束*/

    /*"左侧复选框和列表"方法 开始*/
    checkboxGroupsMethods() {
      let that = this;
      return {
        /**
         * @description 电站/逆变器/摄像机-点击事件
         * */
        checkboxChange(val) {
          let valOld = val;
          val = [];
          that.checkboxGroups.checkListSort.forEach(valSort => {
            valOld.forEach(value => {
              if (valSort === value) {
                val.push(valSort);
              }
            });
          });

          const cameraFilter = that.checkboxGroups.cameraFilter;
          that.$refs.childInputWithButton.value = "";

          let dataListFiltered = [];

          let dataList = that.checkboxGroups.dataList;
          if (val.length > 0) {
            val.forEach((v) => {
              dataListFiltered = dataListFiltered.concat(
                  dataList.filter((item) => {
                    if (v.indexOf(cameraFilter) > -1) {
                      return item.type.indexOf(cameraFilter) > -1;
                    }
                    return item.type === v;
                  })
              );
            });
          }

          that.checkboxGroups.dataListFiltered = dataListFiltered;
          that.activeIndex = 0
          if (dataListFiltered.length > 0) {
            that.electricityMethods().getPVGenElectricityInfo(dataListFiltered[0].id, dataListFiltered[0].type);

            that.checkboxGroups.menuData.PVList = dataListFiltered.filter(
                (value) => {
                  return value[that.checkboxGroups.latitude] !== undefined;
                }
            );
            if (that.checkboxGroups.menuData.PVList.length > 0) {
              that.checkboxGroups.menuData.PVClick =
                  that.checkboxGroups.menuData.PVList[0];
            }
            that.dealVideoOption(dataListFiltered[0])
          } else {
            that.checkboxGroups.menuData.PVList = [];
            that.checkboxGroups.menuData.PVClick = {};
            that.dealVideoOption({})
          }
        },

        /*"获取列表" 方法开始*/
        async getDataList() {
          const cameraFilter = that.checkboxGroups.cameraFilter;
          let res = await api.photovoltaicGetPvList({
            projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))[
                "projects"
                ][0].projectId,
          });
          if (res && res.status === 200) {
            let data = res.data.data;
            that.checkboxGroups.dataList = data;
            that.checkboxGroups.dataListFiltered = [];
            that.checkboxGroups.checkList.forEach((v) => {
              that.checkboxGroups.dataListFiltered =
                  that.checkboxGroups.dataListFiltered.concat(
                      data.filter((item) => {
                        if (v.indexOf(cameraFilter) > -1) {
                          return item.type.indexOf(cameraFilter) > -1;
                        }
                        return item.type === v;
                      })
                  );
            });
          }

          if (that.checkboxGroups.dataListFiltered.length > 0) {
            that.checkboxGroups.itemCurrent =
                that.checkboxGroups.dataListFiltered[0];
            that.dealVideoOption(that.checkboxGroups.dataListFiltered[0])
            await that
                .electricityMethods()
                .getPVGenElectricityInfo(
                    that.checkboxGroups.dataListFiltered[0].id,
                    that.checkboxGroups.dataListFiltered[0].type
                );

            that.checkboxGroups.menuData.PVList =
                that.checkboxGroups.dataListFiltered.filter((value) => {
                  return value[that.checkboxGroups.latitude] !== undefined;
                });
            if (that.checkboxGroups.menuData.PVList.length > 0) {
              that.checkboxGroups.menuData.PVClick =
                  that.checkboxGroups.menuData.PVList[0];
            }
          }
        },
        /*"获取列表" 方法结束*/

        search(val) {
          const cameraFilter = that.checkboxGroups.cameraFilter;
          let checkList = that.checkboxGroups.checkList;

          if (checkList.length === 0) {
            return;
          }

          let dataList = that.checkboxGroups.dataList;
          let dataListFiltered = [];

          checkList.forEach((v) => {
            dataListFiltered = dataListFiltered.concat(
                dataList.filter((item) => {
                  if (v.indexOf(cameraFilter) > -1) {
                    return item.type.indexOf(cameraFilter) > -1;
                  }
                  return item.type === v;
                })
            );
          });

          dataListFiltered = dataListFiltered.filter(
              (item) => item.name.indexOf(val) > -1
          );
          that.checkboxGroups.dataListFiltered = dataListFiltered;

          that.checkboxGroups.menuData.PVList = dataListFiltered.filter(
              (value) => {
                return value[that.checkboxGroups.latitude] !== undefined;
              }
          );
        },

        elMenuItemClick(item) {
          that.checkboxGroups.itemCurrent = item;
          let id = item.id;
          let type = item.type;
          that.electricityMethods().getPVGenElectricityInfo(id, type);
          that.$refs.childElectricity.period = "日";
          that.electricity.echarts.chartsData = {
            xData: [],
            yData: [],
            unit: "kw·h",
          };

          // if (item[that.checkboxGroups.latitude] !== undefined) {
          that.checkboxGroups.menuData.PVClick = item;
          // }
        },
      };
    },
    initVideoOption() {
      this.activeItem = {
        url: "",
        urlBack: ""
      },
          // this.notPlay=true
          // this.timeFormatStr=''
          // this.isLive=true
          // this.isPlay=false
          // this.visibleRate=false
          //当前播放速率
          // this.rate=1.0,
          //点击电站，需要先查询
          this.stationIdVideo = null
      this.inverterIdVideo = null
    },
    dealVideoOption(data) {
      this.initVideoOption()
      if (this._.isEmpty(data)) {
        return
      }
      const {type = '电站', id, RTSP = ""} = data
      this.activeItem = {
        ...data,
        url: `ws://127.0.0.1:8888/rtsp?url=rtsp://${RTSP || ""}`,
        urlBack: `ws://127.0.0.1:8888/rtsp?url=rtsp://${(RTSP || "").replace('Channels', 'tracks')}?${this.timeFormatStr}`
      }
      if (type === '电站') {
        this.stationIdVideo = id
        this.inverterIdVideo = null
      }
      if (type === '逆变器') {
        this.stationIdVideo = null
        this.inverterIdVideo = id
      }
      if (type.includes('摄像头')) {
        this.stationIdVideo = null
        this.inverterIdVideo = null
      }
    },
    treeClick(data = {item, index}) {
      console.log("treeClick--data--", data);
      const {item, index} = data
      this.activeIndex = index
      const {type = '电站', id} = item
      this.dealVideoOption(item)
      this.checkboxGroups.itemCurrent = item;
      this.electricityMethods().getPVGenElectricityInfo(id, type);
      this.$refs.childElectricity.period = "日";
      this.electricity.echarts.chartsData = {
        xData: [],
        yData: [],
        unit: "kw·h",
      };

      this.checkboxGroups.menuData.PVClick = item;
    },
    /*"左侧复选框和列表"方法 结束*/

    /*"发电信息"方法 开始*/
    electricityMethods() {
      let that = this;
      return {
        /* 值转换，如果大于 10000 则除以 10000，保留两位小数（四舍五入） */
        transferValue(value) {
          if (value >= 10000) value = value / 10000;
          return value.toFixed(2);
        },

        /* 单位转换，如果值大于 10000，则单位加上 "万" */
        transferUnit(value) {
          if (value > 10000) return "万 kw·h";
          return "kw·h";
        },
        /*打开 "发电信息" 图表弹窗 开始*/
        async openDialogElectricity(data) {
          await that.electricityMethods().findGenAndPeriodEC(data);
        },
        /*打开 "发电信息" 图表弹窗 结束*/

        /*"日，月，年"切换 开始*/
        async periodChange(data) {
          await that.electricityMethods().findGenAndPeriodEC(data);
        },
        /*"日，月，年"切换 结束*/

        async findGenAndPeriodEC(data) {
          let period = "hour";
          let format = "HH:mm";
          if (data.period === "月") {
            period = "day";
            format = "MM-DD";
          } else if (data.period === "年") {
            period = "month";
            format = "YYYY-MM";
          } else {
            period = "hour";
            format = "HH:mm";
          }
          let keyArr = [];
          that.electricity.echarts.chartsData.xData = [""];
          that.electricity.echarts.chartsData.yData = [0];
          let params = {};
          let type = that.checkboxGroups.itemCurrent.type;
          if (type === "电站") {
            params = {
              startTime: data.startTime,
              endTime: data.endTime,
              period: period,
              needPeriodEc: false,
              stationId: that.checkboxGroups.itemCurrent.id,
              isPower: false,
            };
          } else if (type === "逆变器") {
            params = {
              startTime: data.startTime,
              endTime: data.endTime,
              period: period,
              needPeriodEc: false,
              inverterId: that.checkboxGroups.itemCurrent.id,
              isPower: false,
            };
          } else {
            params = {
              startTime: data.startTime,
              endTime: data.endTime,
              period: period,
              needPeriodEc: false,
              projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
                  .projects[0].projectId,
              isPower: false,
            };
          }

          let res = await api.photovoltaicFindGenAndPeriodEC(params);
          let tsValue = res.data.data["tsValue"];
          for (let key in tsValue) {
            keyArr.push(parseInt(key));
          }
          keyArr.sort((a, b) => {
            return a - b;
          });

          let xData = [];
          let yData = [];

          keyArr.forEach((value) => {
            let timestamp = that.$moment(value).format(format);
            xData.push(timestamp);
            yData.push(tsValue[value]["EC_Hour"].toFixed(2));
          });

          that.electricity.echarts.chartsData.xData = xData;
          that.electricity.echarts.chartsData.yData = yData;
        },

        /* "发电信息" 方法开始 */
        async getPVGenElectricityInfo(id, type) {
          let params = {};
          if (type === "电站") {
            params = {stationId: id};
          } else if (type === "逆变器") {
            params = {inverterId: id};
          } else {
            return;
          }

          let nameValues = [];
          let res = await api.photovoltaicGetPVGenElectricityInfo(params);
          let data = res.data.data;
          let objDay = {
            name: "今日发电",
            value: that.electricityMethods().transferValue(data.day),
            unit: that.electricityMethods().transferUnit(data.day),
          };
          let objMonth = {
            name: "本月发电",
            value: that.electricityMethods().transferValue(data.month),
            unit: that.electricityMethods().transferUnit(data.month),
          };
          let objYear = {
            name: "今年发电",
            value: that.electricityMethods().transferValue(data.year),
            unit: that.electricityMethods().transferUnit(data.year),
          };
          let objTotal = {
            name: "累计发电",
            value: that.electricityMethods().transferValue(data.total),
            unit: that.electricityMethods().transferUnit(data.total),
          };

          nameValues.push(objDay);
          nameValues.push(objMonth);
          nameValues.push(objYear);
          nameValues.push(objTotal);

          that.electricity.nameValues = nameValues;
        },
        /* "发电信息" 方法结束 */
      };
    },
    /*"发电信息"方法 结束*/
    heightResize() {
      if (window.innerWidth >= 2560) {
        this.videoHeight = 'height: 1015px'
        this.mapStyle = 'width: 100%;height: 1260px'
        this.listHeight = '1093px'
      } else {
        this.videoHeight = 'height: 520px'
        this.mapStyle = 'width: 100%;height: 657px'
        this.listHeight = '550px'
      }
    }
  },
  created() {
    this.summaryMethods().getSummaries();
    this.checkboxGroupsMethods().getDataList();
    this.heightResize();
  },
  mounted() {
    this.$bus.$on("getMapClickFun", (data) => {
      const index = this._.findIndex(this.checkboxGroups.dataListFiltered, function (o) {
        return o.id === data.id;
      })
      this.treeClick({item: data, index})
    });
    window.addEventListener("resize", this.heightResize);
  },
  beforeDestroy() {
    this.$bus.$off("getMapClickFun");
    window.removeEventListener("resize", this.heightResize);
  },

};
</script>

<style scoped lang="scss">
$colorActive: #28cccb;
$colorNotActive: #999999;
$colorAlarm: #ec5453;
$colorMain: #28cccb;

#flexBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.el-menu {
  border-right: none;
}

button.search {
  background-color: #28cccb;
  color: #ffffff;
  border: 1px solid #28cccb;
  border-bottom-left-radius: unset;
  border-top-left-radius: unset;
}

div.container-el-tooltip {
  display: inline-block;
  margin-top: 3px;
}

table.video-title {
  width: 100%;
}

img.chart-action:hover {
  cursor: pointer;
}

img.chart-action {
  width: 20px;
}

td.container-four-squares {
  padding-left: 10px;
  padding-right: 10px;
}

.el-carouse-item-my:hover {
  cursor: pointer;
}

span.summary-value-separator {
  color: $colorNotActive;
}

div.container-carousel {
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  display: inline-block;
  width: 41%;
  text-align: center;
  padding: 10px;
  margin-bottom: 10px;
}

div.container-carousel:hover {
  border: 1px solid $colorMain;
  color: $colorMain;
  border-radius: 5px;
  display: inline-block;
  width: 41%;
  text-align: center;
  padding: 10px;
  margin-bottom: 10px;
}

div.container-carousel-separator {
  display: inline-block;
  width: 6%;
}

span.active-1 {
  color: $colorActive;
}

span.notActive {
  color: $colorNotActive;
}

span.alarm-1 {
  color: $colorAlarm;
}

span.summary-value-1 {
  font-weight: bold;
  font-size: 30px;
}

span.highlight {
  color: #28cccb;
}

td.prefix {
  padding-right: 10px;
}

span.circle {
  display: inline-block;
  height: 12px;
  width: 12px;
  border-radius: 6px;
}

span.device-name {
  display: inline-block;
  width: 90%;
}

span.active {
  background-color: $colorActive;
}

span.inactive {
  background-color: $colorNotActive;
}

span.alarm {
  background-color: $colorAlarm;
}

div.container-echarts-electricity {
  width: 100%;
  height: 600px;
}

table.container-carousel {
  width: 100%;
  text-align: center;
  vertical-align: middle;

  > tr {
    height: 50px;

    > td {
      padding: 10px;
    }

    > td:hover {
      background-color: #ffffff;
    }
  }
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 7px;
  height: 7px;
  background: transparent;
  border: 1px solid $colorMain;
  border-radius: 50%;
  opacity: 0.5;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 7px;
  height: 7px;
  background: $colorMain;
  border-radius: 50%;
  opacity: 1;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

button.echarts {
  margin-left: 20px;
}

div.container {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 6px;
}

div.photovoltaicSystem {
  @include setPage;
}

div.container-name-value {
  text-align: center;
  display: inline-block;
  padding: 10px 45px;
}

div.container-name-value-hover {
  cursor: pointer;
}
</style>
